import {
	isMqttURL,
	type MqttURL,
} from "@bracket/rabbit/types";


export const getMqttURL = (): MqttURL => {
	const {
		hostname,
		protocol,
		port,
	} = document.location;
	const sprotocol = protocol === "http:" ? "ws:" : "wss:";
	let URL:string;
	if(hostname === "localhost") {
		URL = `${sprotocol}//public:public@localhost:${port}/api/notifications/ws`;
	}
	else {
		URL =`${sprotocol}//public:public@${hostname}${port ? `:${port}` : ""}/api/notifications/ws`;
	}
	if(isMqttURL(URL)) {
		return URL;
	}
	throw new Error(`configuration error - MQTT connection URL is not valid. [${URL}]`);
}
